export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR'

export const FETCH_TOP_FLIRTS = 'FETCH_TOP_FLIRTS'
export const FETCH_TOP_FLIRTS_SUCCESS = 'FETCH_TOP_FLIRTS_SUCCESS'
export const FETCH_TOP_FLIRTS_ERROR = 'FETCH_TOP_FLIRTS_ERROR'

export const SEE_LIST = 'SEE_LIST'
export const HIDE_LIST = 'HIDE_LIST'
